"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assignments = _interopRequireDefault(require("./assignments.js"));
var _classReports = _interopRequireDefault(require("./classReports.js"));
var _index = _interopRequireDefault(require("./cme/index.js"));
var _loading = _interopRequireDefault(require("./loading.js"));
var _loadedAt = _interopRequireDefault(require("./loadedAt.js"));
var _modal = _interopRequireDefault(require("./modal.js"));
var _notifications = _interopRequireDefault(require("./notifications.js"));
var _organizationalMemberships = _interopRequireDefault(require("./organizationalMemberships.js"));
var _organizationalSubscriptions = _interopRequireDefault(require("./organizationalSubscriptions.js"));
var _organizations = _interopRequireDefault(require("./organizations.js"));
var _productPages = _interopRequireDefault(require("./productPages.js"));
var _questionBanks = _interopRequireDefault(require("./questionBanks.js"));
var _questions = _interopRequireDefault(require("./questions.js"));
var _index2 = _interopRequireDefault(require("./quizzes/index.js"));
var _session = _interopRequireDefault(require("./session.js"));
var _staticData = _interopRequireDefault(require("./staticData.js"));
var _subjects = _interopRequireDefault(require("./subjects.js"));
var _subscriptions = _interopRequireDefault(require("./subscriptions.js"));
var _users = _interopRequireDefault(require("./users.js"));
var _patientTabGroups = _interopRequireDefault(require("./patientTabGroups.js"));
var _products = _interopRequireDefault(require("./products.js"));
var _practiceExamTemplates = _interopRequireDefault(require("./practiceExamTemplates.js"));
var _responses = _interopRequireDefault(require("./responses.js"));
var _reports = _interopRequireDefault(require("./reports.js"));
var _riskAssessment = _interopRequireDefault(require("./riskAssessment.js"));
var _performanceAllStudents = _interopRequireDefault(require("./performanceAllStudents.js"));
var _performanceOrgPeers = _interopRequireDefault(require("./performanceOrgPeers.js"));
var _performancePeers = _interopRequireDefault(require("./performancePeers.js"));
var _performanceQuestions = _interopRequireDefault(require("./performanceQuestions.js"));
var _performanceResponses = _interopRequireDefault(require("./performanceResponses.js"));
var _addonAccessTrackers = _interopRequireDefault(require("./addonAccessTrackers.js"));
var _memberGroups = _interopRequireDefault(require("./memberGroups.js"));
var _memberGroupMembers = _interopRequireDefault(require("./memberGroupMembers.js"));
var _examTemplates = _interopRequireDefault(require("./examTemplates.js"));
var _staffOrganizations = _interopRequireDefault(require("./staffOrganizations.js"));
var _clinicalPearls = _interopRequireDefault(require("./clinicalPearls.js"));
var _categories = _interopRequireDefault(require("./categories.js"));
var _boardExamDates = _interopRequireDefault(require("./boardExamDates.js"));
var _creditCards = _interopRequireDefault(require("./creditCards.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var _default = exports.default = _objectSpread(_objectSpread({
  assignments: _assignments.default,
  classReports: _classReports.default,
  loading: _loading.default,
  loadedAt: _loadedAt.default,
  modal: _modal.default,
  responses: _responses.default,
  notifications: _notifications.default,
  organizationalMemberships: _organizationalMemberships.default,
  organizationalSubscriptions: _organizationalSubscriptions.default,
  organizations: _organizations.default,
  productPages: _productPages.default,
  questionBanks: _questionBanks.default,
  questions: _questions.default,
  quizzes: _index2.default,
  session: _session.default,
  staticData: _staticData.default,
  subjects: _subjects.default,
  subscriptions: _subscriptions.default,
  users: _users.default,
  patientTabGroups: _patientTabGroups.default,
  products: _products.default,
  practiceExamTemplates: _practiceExamTemplates.default,
  reports: _reports.default,
  riskAssessment: _riskAssessment.default,
  performanceAllStudents: _performanceAllStudents.default,
  performanceOrgPeers: _performanceOrgPeers.default,
  performancePeers: _performancePeers.default,
  performanceQuestions: _performanceQuestions.default,
  performanceResponses: _performanceResponses.default,
  addonAccessTrackers: _addonAccessTrackers.default
}, _index.default), {}, {
  memberGroups: _memberGroups.default,
  memberGroupMembers: _memberGroupMembers.default,
  examTemplates: _examTemplates.default,
  staffOrganizations: _staffOrganizations.default,
  clinicalPearls: _clinicalPearls.default,
  categories: _categories.default,
  boardExamDates: _boardExamDates.default,
  creditCards: _creditCards.default
});